export default "__VITE_ASSET__CBr1XRvJ__"